export const headApi = `https://www.bangles.org.in:8443/api/rest`;

export const adminId = "1"; //https://api.bangles.org.in/api/rest/user/+919967698236

// export const localApi = `http://localhost:8085/api`
// export const localApi = `https://bangles.org.in:8443/api`;
export const localApi = `https://api.inshabangles.com/api`;